export enum AreaType {
  Upsell = 'Upsell',
  Rural = 'Rural',
  Fwa = 'Fwa',
  FwaLowband = 'FwaLowband',
  FwaSiteDevelopment = 'FwaSiteDevelopment',
  MassMarket = 'MassMarket',
  UpsellOperatorChange = 'UpsellOperatorChange'
}

export enum AreaStatus {
  SaleInProgress = 'SaleInProgress',
  BuildingInProgress = 'BuildingInProgress',
  Status679 = 'Status679',
  RuralInterest = 'RuralInterest',
  RuralInterestAfterBuilding = 'RuralInterestAfterBuilding',
  RuralInterestAfterSalesQuote = 'RuralInterestAfterSalesQuote',
  RuralInterestAfterSalesSuc = 'RuralInterestAfterSalesSuc',
  FwaInterest = 'FwaInterest',
  FwaInterestAfterBuilding = 'FwaInterestAfterBuilding',
  FwaLowbandInterest = 'FwaLowbandInterest',
  FwaSiteDevelopmentInterest = 'FwaSiteDevelopmentInterest',
  FwaSiteDevelopmentInterestAfterBuilding = 'FwaSiteDevelopmentInterestAfterBuilding',
  UpsellOperatorChangeNoCampaign = 'UpsellOperatorChangeNoCampaign'
}

export enum PhaseStatus {
  StatusNotStarted = 'StatusNotStarted',
  StatusStarted = 'StatusStarted',
  StatusCompleted = 'StatusCompleted'
}

export enum DeliveryOptions {
  ExpressDelivery = 'ExpressDelivery',
  PlannedDelivery = 'PlannedDelivery'
}

export enum OperatorType {
  OTHER = 'Annan'
}
